const slideout = () => {
    document.addEventListener('DOMContentLoaded', function(){
        const originalBtnContainer = document.querySelectorAll('.fndry-slideout-block__heading-wrap');
    
        if(originalBtnContainer){
            const originalBtn = document.querySelectorAll('.fndry-slideout-toggle');
            originalBtn.forEach(function(btn, index){
                btn.remove();
            });
    
            const blockContent = document.querySelectorAll('.fndry-slideout-block__content');
            if(blockContent){
                blockContent.forEach(function(block, index){
                    const newBtn = document.createElement('span');
                
                    newBtn.textContent = 'Details';
    
                    newBtn.classList.add('fndry-slideout-toggle--new');
    
                    block.appendChild(newBtn);
                })
            }
    
        }
    })
}

export default slideout;